<ng-container *ngIf="isLoaded; else loadingState">
  <app-blocks-workflow [blocks]="workflow.blocks" [models]="workflow.models" [context]="workflow.context"></app-blocks-workflow>
</ng-container>
<ng-template #loadingState>
  <div class="spinner-wrapper spinner-wrapper-allpage">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
